import { ADD_TOAST_MESSAGE } from 'vuex-toast';

const state = () => ({
  language: false, //'it'//TODO set to undefined or false
  privacy: false,
});

const getters = {
  language: (actualState) => actualState.language,
  privacy: (actualState) => actualState.privacy,
};

const actions = {
  setLanguage({ commit, dispatch }, language) {
    try {
      commit('SET_LANGUAGE', language);
    } catch (e) {
      dispatch(ADD_TOAST_MESSAGE, {
        text:
          (e.data || {}).message ||
          'somethings bad happen, please try again later',
        type: 'danger',
      });
    }
  },
  setPrivacy({ commit, dispatch }, accept) {
    try {
      commit('SET_ACCEPT', accept);
    } catch (e) {
      dispatch(ADD_TOAST_MESSAGE, {
        text:
          (e.data || {}).message ||
          'somethings bad happen, please try again later',
        type: 'danger',
      });
    }
  },
};

const mutations = {
  SET_LANGUAGE: (actualState, language) => (actualState.language = language),
  SET_ACCEPT: (actualState, privacy) => (actualState.privacy = privacy),
};
export default {
  state,
  getters,
  actions,
  mutations,
};
